export const InvitationRoutes = {
  SIGN_UP: 'sign-up',
  TEAM: 'teams',
  LOGIN: 'login',
  HOME: 'home'
};
